import IconButton from '@material-ui/core/IconButton';
import React from 'react';
import {ReactComponent as RotateLeftDisabledIcon} from '../../assets/icons/rotate_left-disabled.svg';
import {ReactComponent as RotateLeftIcon} from '../../assets/icons/rotate_left.svg';
import {ReactComponent as RotateRightDisabledIcon} from '../../assets/icons/rotate_right-disabled.svg';
import {ReactComponent as RotateRightIcon} from '../../assets/icons/rotate_right.svg';
import DropdownMenuZoom from '../../components/DropdownMenu/DropdownMenuZoom.component';
import { ZoomInOut } from '../../components/DropdownMenu/ZoomInOut.component';
import { zoomFactorValues } from '../../components/Solution/Preview.types';
import TooltipOne from '../../components/TooltipOne/TooltipOne.component';
import { fill, fillOpacity } from '../../utils/contrastSvgAttributes';

interface ImageEditorProps {
  zoomFactor: number;
  cardPreviewMenuIconClass: string;
  handleZoomIn: () => void;
  handleZoomOut: () => void;
  handleZoomChange: (event: any) => void;
  handleRotateLeft: () => void;
  handleRotateRight: () => void;
  saving: boolean;
}

const ImageEditor: React.FC<ImageEditorProps> = (props) => {
  return (
    <>
      <ZoomInOut zoomFactor={props.zoomFactor} handleZoomIn={props.handleZoomIn} handleZoomOut={props.handleZoomOut} />
      <TooltipOne title="Obróć o 90 stopni w lewo" placement="top">
        <IconButton
          disableRipple
          onClick={props.handleRotateLeft}
          disabled={props.saving}
        >
          {!props.saving ? <RotateLeftIcon title="ikona obrotu w lewo" fill={fill} /> : <RotateLeftDisabledIcon  fill={fill} fillOpacity={fillOpacity} title="ikona obrotu w lewo" style={{ cursor: props.saving ? 'not-allowed' : 'default' }}/>}
        </IconButton>
      </TooltipOne>
      <TooltipOne title="Obróć o 90 stopni w prawo" placement="top">
        <IconButton
          disableRipple
          onClick={props.handleRotateRight}
          disabled={props.saving}
        >
          {!props.saving ? <RotateRightIcon title="ikona obrotu w prawo" fill={fill} /> : <RotateRightDisabledIcon fill={fill} fillOpacity={fillOpacity} title="ikona obrotu w prawo" style={{ cursor: props.saving ? 'not-allowed' : 'default' }}/>}
        </IconButton>
      </TooltipOne>
      <DropdownMenuZoom
        handleZoomChange={props.handleZoomChange}
        zoomFactor={props.zoomFactor}
        zoomValues={zoomFactorValues}
      />
    </>
  );
};

export default React.memo(ImageEditor);
